/* @flow */
import React from 'react';
import { Container } from 'flux/utils';
import CurrentUser from 'auth/CurrentUser';
import ActivitiesClassViewHeaderActions from 'payments/components/ActivitiesClassViewHeaderActions.jsx';

type State = {
  canCreateActivity: boolean,
  canGoToTransactionSettings: boolean,
};

class ActivitiesClassViewHeaderActionsContainer extends React.Component {
  state: State;

  static getStores() {
    return [
      CurrentUser,
    ];
  }

  static calculateState() {
    const canCollectMoney = CurrentUser.getUser().canCollectMoney();
    const canSendMoney = CurrentUser.getUser().canSendMoney();

    return {
      canGoToTransactionSettings: canCollectMoney || canSendMoney,
      canCreateActivity: CurrentUser.getUser().canCreateActivity(),
    };
  }

  render() {
    return (
      <ActivitiesClassViewHeaderActions
        canCreateActivity={this.state.canCreateActivity}
        canGoToTransactionSettings={this.state.canGoToTransactionSettings}
      />
    );
  }
}

export default Container.create(ActivitiesClassViewHeaderActionsContainer);



// WEBPACK FOOTER //
// ./src/payments/containers/ActivitiesClassViewHeaderActionsContainer.jsx